
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Building, Hash } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../types";
import { concessionarias } from "@/types";

interface ConcessionariaSectionProps {
  form: UseFormReturn<ClienteFormValues>;
  usarDadosGerador: boolean;
}

const ConcessionariaSection = ({ form, usarDadosGerador }: ConcessionariaSectionProps) => {
  return (
    <div className="bg-green-50 p-4 rounded-md">
      <h3 className="text-sm font-medium text-green-800 mb-3 flex items-center">
        <Building className="h-4 w-4 mr-2" />
        Dados da Concessionária
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField
          control={form.control}
          name="concessionaria"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Concessionária</FormLabel>
              <Select 
                onValueChange={field.onChange} 
                defaultValue={field.value}
                disabled={usarDadosGerador}
              >
                <FormControl>
                  <SelectTrigger className={`border-green-200 focus:border-green-500 ${usarDadosGerador ? 'bg-muted' : ''}`}>
                    <SelectValue placeholder="Selecione a concessionária" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {concessionarias.map((concessionaria) => (
                    <SelectItem 
                      key={concessionaria} 
                      value={concessionaria}
                    >
                      {concessionaria}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="numeroCliente"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Número do Cliente</FormLabel>
              <FormControl>
                <div className="relative">
                  <Hash className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                  <Input {...field} placeholder="Número do cliente" className="pl-8 border-green-200 focus:border-green-500" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="numeroInstalacao"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Número da Instalação</FormLabel>
              <FormControl>
                <div className="relative">
                  <Hash className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                  <Input {...field} placeholder="Número da instalação" className="pl-8 border-green-200 focus:border-green-500" />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};

export default ConcessionariaSection;
